require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-sample-item-group-article-do-not-delete.json") })
        }
      }, "path---articles-sample-item-group-article-do-not-delete");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-sample-item-group-article-do-not-delete!./.cache/json/articles-sample-item-group-article-do-not-delete.json
// module id = 1728
// module chunks = 231608221292675